import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import classNames from 'classnames';

import Button from './Button';
import { ImageService } from '../../../main/services/ImageService/ImageService';

class AddFieldButton extends React.Component {
  static propTypes = {
    containerClassName: PropTypes.string,
  };

  static defaultProps = {
    containerClassName: '',
    testid: 'add-field',
  };

  render() {
    const label = typeof this.props.children === 'string' ? this.props.children : 'Add field button';
    const i13nModel = R.merge({ label }, this.props.i13nModel);

    const buttonProps = R.omit(['containerClassName', 'i13nModel'], this.props);

    return (
      <div className={classNames('add-field', this.props.containerClassName)}>
        <Button size="no-miw" type="dashed" i13nModel={i13nModel} {...buttonProps}>
          {this.props.children}
          <img className="add-field-icon" src={ImageService.getImageUrl('/static/images/editor/ic_add_button.svg')} />
        </Button>
      </div>
    );
  }
}

export default AddFieldButton;
